var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "stroke",
    d: "M22.2501 25.2498C22.2501 25.8466 22.0131 26.4188 21.5911 26.8408C21.1692 27.2627 20.5969 27.4998 20.0002 27.4998C19.4034 27.4998 18.8311 27.2627 18.4092 26.8408C17.9872 26.4188 17.7502 25.8466 17.7502 25.2498M20.5409 14.7523L19.4414 14.75C16.9335 14.744 14.7563 16.7817 14.739 19.2499V22.0924C14.739 22.6849 14.664 23.2631 14.3408 23.7559L14.1255 24.0843C13.7978 24.5823 14.1503 25.2498 14.739 25.2498H25.2613C25.8501 25.2498 26.2018 24.5823 25.8748 24.0843L25.6596 23.7559C25.3371 23.2631 25.2613 22.6841 25.2613 22.0916V19.2507C25.2313 16.7817 23.0489 14.7583 20.5409 14.7523V14.7523Z",
    stroke: "none",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "stroke",
    d: "M20.0002 12.5C20.398 12.5 20.7796 12.658 21.0609 12.9393C21.3422 13.2206 21.5002 13.6022 21.5002 14V14.75H18.5002V14C18.5002 13.6022 18.6583 13.2206 18.9396 12.9393C19.2209 12.658 19.6024 12.5 20.0002 12.5Z",
    stroke: "none",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.87154776dd420b5db5591212968a45b8.svg";
export { ForwardRef as ReactComponent };